module.exports = __webpack_public_path__ + "static/media/mandy.8cc703a9.png";